import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import {
  PaymentOutcomeActions,
  PaymentOutcomeLayout,
} from "investment/PaymentOutcomeLayout";
import { clearPendingCheckout, readPendingCheckout } from "lib/investmentHelper";
import { parseOptionalQueryNumber, parseQueryNumber } from "lib/queryParams";

export default function InvestmentPaymentCancelPage() {
  const [searchParams] = useSearchParams();
  const pending = useMemo(() => readPendingCheckout(), []);

  useEffect(() => {
    clearPendingCheckout();
  }, []);

  const projectId =
    searchParams.get("project_id") ||
    searchParams.get("campaignId") ||
    pending?.projectId ||
    null;
  const amount =
    parseOptionalQueryNumber(searchParams.get("amount")) ?? pending?.amount ?? null;
  const minInvestment = parseQueryNumber(searchParams.get("min"), 0);

  return (
    <PaymentOutcomeLayout
      variant="cancel"
      pageTitle="Payment cancelled"
      title="Payment cancelled"
      description="You left Stripe Checkout before completing payment. No charge was made to your account."
      primaryAction={
        <PaymentOutcomeActions
          campaignId={projectId}
          amount={amount}
          showRetry={Boolean(projectId)}
        />
      }
      secondaryAction={
        minInvestment > 0 ? (
          <p className="text-xs text-muted-foreground">
            Minimum investment for this offering: $
            {minInvestment.toLocaleString("en-US")}
          </p>
        ) : null
      }
    />
  );
}
